import React, { useEffect, useState } from 'react';
import { websocketConnection } from 'utils/websocket';
import { useQueryParams } from 'utils/useQueryParams';
// @ts-ignore
import { getGPSUserId } from 'utils/utility';

// @ts-ignore
import infoIcon from 'assets/images/achievements/info.svg';

import {
  Wrapper,
  Icon,
  Text
} from './styled';

const ReviewSummary: React.FC = () => {
  const [reviewText, setReviewText] = useState<string>('');
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [error, setError] = useState<boolean>(false);

  const { journey: journeyId, area: areaName, start, end } = useQueryParams();
  const userId = getGPSUserId();

  useEffect(() => {
    // Set loading to true when query params change
    setIsLoading(true);
    setError(false);
    
    if (start && end && userId) {
      websocketConnection.connect(fetchReviewSummary, handleError);
      websocketConnection.setMessageCallback(handleMessage);
    }

    return () => {
      websocketConnection.close();
    };
  }, [journeyId, areaName, start, end, userId]);

  const fetchReviewSummary = () => {
    if (!start || !end || !userId) {
      setIsLoading(false);
      return;
    }

    const data: any = {
      user_id: userId,
      start_date: start,
      end_date: end
    };

    // Only add journeyId and areaName if they're available
    if (journeyId) {
      data.masterplan_id = journeyId;
    }
    
    if (areaName) {
      data.user_area_name = areaName;
    }

    const payload = {
      endpoint: "generate_year_in_review_prompt",
      data
    };

    websocketConnection.send(JSON.stringify(payload));
  };

  const handleMessage = (message: string) => {
    try {
      const response = JSON.parse(message);
      
      if (response.ping || response.pong) {
        return;
      }

      if (response.message && response.message.year_in_review_summary) {
        setReviewText(response.message.year_in_review_summary);
        setIsLoading(false);
      }
    } catch (error) {
      console.error('Error parsing WebSocket message:', error);
      setError(true);
      setIsLoading(false);
    }
  };

  const handleError = () => {
    setError(true);
    setIsLoading(false);
  };

  return (
    <Wrapper>
      <Icon src={infoIcon} alt="" />
      <Text>
        {isLoading ? "Loading review summary..." :
         error ? "Failed to load review summary. Please try again later." :
         reviewText}
      </Text>
    </Wrapper>
  );
};

export default ReviewSummary;